// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"25aaa391","311":"64980096","550":"7bb71d3f"}[chunkId] + ".chunk.css";
};